import RequirementsCardLTR from '../../../../components/requirements-card-ltr/index';
import requirementsCardLTR from './index';

export default requirementsCardLTR(RequirementsCardLTR);
